import * as React from "react";
import { DataLayer } from "@grandvisionhq/analytics";
import { useIntl, useFeatureToggles } from "@grandvisionhq/state";
import { storeDetailsEvent } from "../../../../data-layer/data-layer/actions.js";
import StoreBookAppointmentCTA from "./StoreBookAppointmentCTA.js";
import { getBookAppointmentUrl } from "../../../../utils/utils/store-utils.js";
const StoreBookAppointmentCTAContainer = ({
  url,
  code,
  globalStoreId,
  name,
  town,
  country,
  streetName,
  streetNumber,
  additionalStreetInfo,
  postalCode,
  appointmentTypeId,
  ...rest
}) => {
  const { locale, getLabel } = useIntl();
  const { isMultilingualEnabled, featureConfigs } = useFeatureToggles();
  const {
    appointmentBookingUrlPaddedLength,
    appointmentBookingAlternativeUrl,
    appointmentBookingAlternativeUrlStores
  } = featureConfigs;
  const location = getBookAppointmentUrl(url, {
    paddedLength: appointmentBookingUrlPaddedLength,
    alternativeUrl: appointmentBookingAlternativeUrl && isMultilingualEnabled ? appointmentBookingAlternativeUrl[locale] : appointmentBookingAlternativeUrl,
    alternativeUrlStores: appointmentBookingAlternativeUrlStores
  })({ globalStoreId, code });
  const labels = React.useMemo(
    () => ({
      caption: getLabel("stores.page.details.action.bookAppointment")
    }),
    [getLabel]
  );
  const onClick = React.useCallback(() => {
    const dataLayerEvent = storeDetailsEvent({
      interaction: "book appointment click",
      store: {
        globalStoreId,
        name,
        town,
        country,
        streetName,
        streetNumber,
        additionalStreetInfo,
        postalCode
      }
    });
    if (dataLayerEvent) {
      DataLayer.pushEvent(dataLayerEvent);
    }
    window.location.assign(location);
  }, [
    location,
    globalStoreId,
    name,
    town,
    country,
    streetName,
    streetNumber,
    additionalStreetInfo,
    postalCode
  ]);
  return /* @__PURE__ */ React.createElement(StoreBookAppointmentCTA, { ...rest, labels, onClick });
};
export {
  StoreBookAppointmentCTAContainer as default
};
//# sourceMappingURL=StoreBookAppointmentCTAContainer.js.map
